import { render, staticRenderFns } from "./addbeforeLogin.vue?vue&type=template&id=a68f793e&"
import script from "./addbeforeLogin.vue?vue&type=script&lang=js&"
export * from "./addbeforeLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a68f793e')) {
      api.createRecord('a68f793e', component.options)
    } else {
      api.reload('a68f793e', component.options)
    }
    module.hot.accept("./addbeforeLogin.vue?vue&type=template&id=a68f793e&", function () {
      api.rerender('a68f793e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/announcement/components/addbeforeLogin.vue"
export default component.exports